import axiosServices from '../utils/axios';

const backendUrl = import.meta.env.VITE_BACKEND_URL;

export const generateAIParticipants = async (data) => {
  const response = await axiosServices.post(`${backendUrl}/ai-participants/generate`, data);
  return response.data;
};

export const fetchAIParticipants = async (paginationModel) => {
  const response = await axiosServices.get(`${backendUrl}/ai-participants`, {
    params: {
      ...paginationModel,
    },
  });
  return response.data;
};
export const fetchAIParticipantById = async ({ participantId }) => {
  const response = await axiosServices.get(`${backendUrl}/ai-participants/${participantId}`);
  return response.data;
};

export const generateAIParticipantsResponses = async (data) => {
  // No process_id needed - backend uses atomic credit deduction with workspace_id from header
  const response = await axiosServices.post(`${backendUrl}/ai-participant-response/generate`, data);
  return response.data;
};
export const generateInterviewAIParticipantsResponses = async (data) => {
  // No process_id needed - backend uses atomic credit deduction with workspace_id from header
  const response = await axiosServices.post(
    `${backendUrl}/ai-participant-response/collect-interview-response`,
    data,
  );
  return response.data;
};

export const deleteAIParticipant = async (id) => {
  const response = await axiosServices.delete(`${backendUrl}/ai-participants/${id}`);
  return response.data;
};

export const bulkdeleteAIParticipant = async (ids) => {
  const response = await axiosServices.delete(`${backendUrl}/ai-participants/bulk/remove`, {
    data: ids,
  });
  return response.data;
};

export const fetchFilterOptions = async () => {
  const response = await axiosServices.get(`${backendUrl}/ai_participant/filter/context`);
  return response.data;
};

export const fetchAIParticipantTags = async () => {
  const response = await axiosServices.get(`${backendUrl}/ai-participants/tags/fetch/`);
  return response.data;
};

export const previewParticipantsCsv = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axiosServices.post(
    `${backendUrl}/ai-participants/import/preview`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    },
  );
  return response.data;
};

export const commitParticipantsImport = async (payload) => {
  const response = await axiosServices.post(`${backendUrl}/ai-participants/import/commit`, payload);
  return response.data;
};

export const createAIParticipantTag = async (data) => {
  const response = await axiosServices.post(`${backendUrl}/ai-participants/tags/`, data);
  return response.data;
};

export const updateAIParticipants = async ({ formData, participantId }) => {
  const response = await axiosServices.patch(
    `${backendUrl}/ai-participants/${participantId}`,
    formData,
  );
  return response.data;
};
